import { __decorate } from "tslib";
import { getPassConfig, updatePassConfig } from '@blade-sxp/device-management-pass/api/device-management';
import { Component, Vue } from 'vue-property-decorator';
import AuthItem from '@blade/common/components/auth/auth-item.vue';
import UploadBox from '@blade-sxp/device-management-pass/components/upload-box/index.vue';
import { uploadLogoIdleImgApi } from '@blade-sxp/device-management-pass/api/index';
let default_1 = class extends Vue {
    previewInfos = {
        logo: [],
        screenCover: [],
    };
    deviceId = '';
    dataSource = {};
    taskList = [];
    taskDeletedList = [];
    passEditStatus = false;
    taskId = '';
    form = {
        livenessThreshold: 98,
        liveness: true,
        deviceRunType: 1,
        recognitionDistance: 1.5,
        openInterval: 3,
        displayInterval: 3,
        screenBrightness: 30,
        standByOpen: true,
        waitTime: 1,
        sleepTime: 3,
        autoReboot: true,
        rebootTime: '02:00:00',
        mode: 1,
        logo: '',
        screenCover: '',
    };
    distanceOptions = {
        // default: 1.5,
        list: [
            {
                label: '0.5m',
                value: 0.5,
            },
            {
                label: '1m',
                value: 1,
            },
            {
                label: '1.5m',
                value: 1.5,
            },
            {
                label: '2m',
                value: 2,
            },
        ],
    };
    verificationMethod = [
        {
            value: 9,
            label: this.$t('faceSwiping'),
        },
        {
            value: 2,
            label: this.$t('faceSwipingCardSwiping'),
        },
        {
            value: 1,
            label: this.$t('faceSwipingOrCardSwiping'),
        },
        {
            value: 10,
            label: this.$t('swipingFaceOrCardOrCode'),
        },
    ];
    uploadChange(data) {
        console.log('uploadChange', data);
        this.previewInfos = data;
    }
    data() {
        return {
            faceMatchThreshold: undefined,
            livenessThreshold: undefined,
        };
    }
    handleEdit() {
        this.passEditStatus = true;
    }
    handleCancel() {
        this.passEditStatus = false;
    }
    handleDeleteTask(task) {
        const { taskId } = task;
        this.taskList.splice(this.taskList.indexOf(task), 1);
        this.taskDeletedList.push(taskId);
    }
    async handleSync() {
        this.passEditStatus = false;
        const form = this.form;
        const data = {
            ...form,
            deviceId: Number(this.deviceId),
        };
        if (data.livenessThreshold) {
            data.livenessThreshold /= 100;
        }
        await this.submitUpload();
        updatePassConfig(data).then((resp) => {
            this.taskId = resp?.lastTaskId || '';
            this.$message.success(resp?.data?.message || `${this.$t('common.success')}`);
            this.taskDeletedList = [];
            // if (this.taskId) { this.handleGotoDetail(); }
        });
    }
    async submitUpload() {
        try {
            const { logo, screenCover } = this.previewInfos;
            const param = {
                logoImage: logo?.[0] ?? '',
                idleImage: screenCover?.[0] ?? '',
                deviceIds: [this.deviceId],
                operateType: 'SINGLE', // 'SINGLE|BATCH',
            };
            await uploadLogoIdleImgApi(param);
        }
        catch (e) {
            console.log(e);
        }
    }
    getData() {
        if (!this.deviceId)
            return;
        getPassConfig(this.deviceId).then((resp) => {
            console.log('getPassConfig resp', resp);
            this.dataSource = resp;
            const { taskList = [], logoImageUrl, idleImageUrl, ...rest } = this.dataSource || {};
            this.taskList = [...taskList];
            this.taskId = this.dataSource?.lastTaskId || '';
            this.form = { ...rest };
            const livenessThreshold = this.dataSource?.livenessThreshold ?? undefined;
            this.form.livenessThreshold = livenessThreshold ? livenessThreshold * 100 : livenessThreshold;
            this.previewInfos.logo = logoImageUrl ? [logoImageUrl] : [];
            this.previewInfos.screenCover = idleImageUrl ? [idleImageUrl] : [];
        });
    }
    mounted() {
        const query = this.$route.query;
        this.deviceId = query.deviceId;
        this.getData();
    }
};
default_1 = __decorate([
    Component({
        components: { AuthItem, UploadBox },
        i18n: {
            messages: {
                en: {
                    pleaseSelect: 'Please select',
                    pleaseInput: 'Please input',
                    open: 'Open',
                    close: 'Close',
                    deviceError: 'Pass task error',
                    deviceRunType: 'Enabled Status',
                    openInterval: 'Open Interval',
                    useShowAvatar: 'Show Avatar',
                    blackListTip: 'Black List Tip',
                    blackListOpen: 'Black List Open',
                    certificateThreshold: 'Certificate Threshold',
                    showUserName: 'Show User Name',
                    mshortExposure: 'Short Exposure',
                    mscreenBrightness: 'Screen Brightness',
                    msoundVolume: 'Volume',
                    mmaskDetect: 'Mask Detect',
                    mnoAccessWithoutMask: 'No Access Without Mask',
                    runing: 'Runing',
                    halt: 'Halt',
                    turnstile: 'Turnstile Mode',
                    accessControl: 'Access Control Mode',
                    swipingFaceOrCard: 'Swiping Face Or Card',
                    swipingFaceAndCard: 'Swiping Face And Card',
                    swipingFaceOrIdentityCard: 'Swiping Face Or Identity Card',
                    swipingFaceAndIdentityCard: 'Swiping Face And Identity Card',
                    swipingFaceAndIdentityCardReservation: 'Swiping Face And Identity Card Reservation',
                    swipingFaceOrCode: 'Swiping Face Or Code',
                    swipingFaceAndCode: 'Swiping Face And Code',
                    bluetooth: 'Bluetooth',
                    swipingface: 'Swiping Face',
                    faceOrQrCodeOrCard: 'Swiping Face Or qrcode or Card',
                    swipingIdentityCard: 'Swiping Identity Card',
                    doorbell: 'Doorbell',
                    alarm: 'Alarm',
                    musicAlarmBell: 'Music Alarm Bell',
                    strangerAlarm: 'Stranger Alarm',
                    maskAlarm: 'Mask Alarm',
                    doorSensor: 'Door Sensor',
                    exitButton: 'Exit Button',
                    fireSignal: 'Fire Signal',
                    securitySettings: 'Security Settings',
                    localRelay: 'Local Relay',
                    wigan26: 'Wigan26(8+16bit ID)',
                    wigan32: 'Wigan32',
                    wigan34: 'Wigan34',
                    networkRelay: 'Network Relay',
                    wigan26Bit24: 'Wigan26(24bit ID)',
                    simplifiedChinese: 'Simplified Chinese',
                    traditionalChinese: 'Traditional Chinese',
                    english: 'English',
                    bkGrdDuration: 'Background Display Duration',
                    recognitionDistance: 'Face Recognition Distance',
                    autoStandby: 'Automatic Standby',
                    standbyDuration: 'Standby Duration',
                    hibernateDuration: 'Hibernate Duration',
                    autoReboot: 'Automatic Reboot',
                    rebootTime: 'Automatic Reboot Time',
                    faceSwiping: 'Face',
                    faceSwipingCardSwiping: 'Face + IC-card',
                    faceSwipingOrCardSwiping: 'Face or IC-card',
                    swipingFaceOrCardOrCode: 'Face or IC-card or QR-code',
                    validityPeriod: 'Period Of Validity',
                },
                zh: {
                    faceSwiping: '人脸',
                    faceSwipingCardSwiping: '刷脸且刷卡',
                    faceSwipingOrCardSwiping: '刷脸或刷卡',
                    verificationMethod: '核验方式',
                    pleaseSelect: '请选择',
                    pleaseInput: '请输入',
                    open: '开启',
                    close: '关闭',
                    deviceError: '通行任务异常',
                    deviceRunType: '启用状态',
                    openInterval: '再次识别间隔',
                    useShowAvatar: '显示头像',
                    blackListTip: '黑名单提示',
                    blackListOpen: '黑名单开门',
                    certificateThreshold: '认证对比阈值',
                    showUserName: '识别成功显示用户名',
                    mshortExposure: '短曝光频率',
                    mscreenBrightness: '屏幕亮度',
                    msoundVolume: '音量',
                    mmaskDetect: '口罩检测',
                    mnoAccessWithoutMask: '不戴口罩不开门',
                    runing: '运行',
                    halt: '停机',
                    turnstile: '闸机模式',
                    accessControl: '门禁模式',
                    swipingFaceOrCard: '刷脸或刷卡',
                    swipingFaceAndCard: '刷脸且刷卡',
                    swipingFaceOrIdentityCard: '刷脸或刷身份证',
                    swipingFaceAndIdentityCard: '刷脸且刷身份证',
                    swipingFaceAndIdentityCardReservation: '刷脸且刷身份证预约',
                    swipingFaceOrCode: '刷脸或扫码',
                    swipingFaceAndCode: '刷脸且扫码',
                    bluetooth: '蓝牙',
                    swipingface: '人脸',
                    faceOrQrCodeOrCard: '人脸或二维码或刷卡',
                    swipingIdentityCard: '刷卡且刷脸',
                    swipingFaceOrCardOrCode: '人脸或刷卡或二维码',
                    doorbell: '门铃',
                    alarm: '报警器',
                    musicAlarmBell: '音乐警铃',
                    strangerAlarm: '陌生人报警',
                    maskAlarm: '口罩报警',
                    doorSensor: '门磁',
                    exitButton: '出门按钮',
                    fireSignal: '消防信号',
                    securitySettings: '保全设定',
                    localRelay: '本地继电器',
                    wigan26: '韦根26(8+16bit ID)',
                    wigan32: '韦根32',
                    wigan34: '韦根34',
                    networkRelay: '网络继电器',
                    wigan26Bit24: '韦根26(24bit ID)',
                    simplifiedChinese: '简体中文',
                    traditionalChinese: '繁体中文',
                    english: '英语',
                    bkGrdDuration: '背景图显示时长',
                    recognitionDistance: '人脸识别距离',
                    autoStandby: '自动待机',
                    standbyDuration: '待机时长',
                    hibernateDuration: '休眠时长',
                    autoReboot: '自动重启',
                    rebootTime: '自动重启时间',
                },
            },
        },
    })
], default_1);
export default default_1;
